import { render } from "./Iframe.vue?vue&type=template&id=7284bc7a&scoped=true"
import script from "./Iframe.vue?vue&type=script&lang=js"
export * from "./Iframe.vue?vue&type=script&lang=js"

import "./Iframe.vue?vue&type=style&index=0&id=7284bc7a&scoped=true&lang=css"

import exportComponent from "/var/www/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7284bc7a"]])

export default __exports__